import { Reveal } from "./Reveal";
import { useI18n } from "../i18n";

export default function Footer() {
  const { tr } = useI18n();
  return (
    <footer className="py-20 border-t wp-rule bg-[#F6FAFF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="grid md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <div className="font-atlas text-4xl text-[#0F2557]">WorldPulse<span className="text-[#2563EB]">.pro</span></div>
              <p className="text-sm text-[#718096] mt-4 max-w-sm leading-relaxed">
                {tr("A living digital record of the world's places, people and communities. The WHERE of the Pulse ecosystem.")}
              </p>
            </div>
            <div className="md:col-span-4">
              <div className="font-mono-wp text-[0.6rem] uppercase tracking-[0.25em] text-[#718096] mb-4">{tr("The Ecosystem")}</div>
              <div className="grid grid-cols-2 gap-x-6 gap-y-2 font-mono-wp text-xs text-[#4A5568]">
                {["SocialPulse", "Indias.com", "USAPulse.net", "FoodPulse", "NaturePulse", "FarmersPulse", "AlumniPulse", "TravelerPulse", "SellnBuy", "IndianFamilyTree"].map((s) => (
                  <span key={s} className="hover:text-[#2563EB] transition-colors duration-300 cursor-default">{s}</span>
                ))}
              </div>
            </div>
            <div className="md:col-span-3">
              <div className="font-mono-wp text-[0.6rem] uppercase tracking-[0.25em] text-[#718096] mb-4">{tr("Coordinates")}</div>
              <div className="font-mono-wp text-xs text-[#4A5568] space-y-2">
                <div>ISO 3166 · GeoNames</div>
                <div>ADM0 — ADM5</div>
                <div>{tr("249 territories · 11M+ places")}</div>
              </div>
            </div>
          </div>
          <div className="atlas-dash mt-14 mb-6" />
          <div className="flex flex-wrap justify-between gap-3 font-mono-wp text-[0.6rem] uppercase tracking-[0.2em] text-[#718096]">
            <span>© {new Date().getFullYear()} WorldPulse — {tr("The Global Geographic Platform")}</span>
            <span>{tr("Built on one knowledge graph. Not millions of websites.")}</span>
          </div>
        </Reveal>
      </div>
    </footer>
  );
}
